export const sessionTimeoutConfig = {
    renewDurationTime: 120,
    sessionDurationTime: 3400000
}